import { Warning } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'

import classes from './index.styles'

const Nh3WarningItem = ({ value, isAlerting }: { value: number; isAlerting: boolean }) => {
  return (
    <Grid container={true} sx={classes.textValueContainer}>
      <Typography variant="caption" sx={classes.ammWarningLabel}>
        {value === 1 ? 'Detected' : 'Not detected'}
      </Typography>
      {isAlerting && <Warning sx={classes.statusItemWarningIcon} />}
    </Grid>
  )
}

export default Nh3WarningItem
